var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0 0 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.13453824,2.89711559 C6.13453824,4.12129554 4.76077697,5.11128455 3.06753632,5.11128455 C2.55317454,5.11128455 2.06756591,5.01973717 1.64159342,4.85793252 C1.21242614,5.19005786 0.685285184,5.39337819 0.125131362,5.45086142 C0.0697549384,5.45724844 0.0165083774,5.4210553 0.00266427151,5.36889459 C-0.0111798344,5.31566937 0.0314174145,5.28266974 0.0729497321,5.24328308 C0.278481458,5.04741429 0.527675363,4.89412567 0.625649036,4.23626201 C0.233754346,3.86475 0.00053440907,3.40062613 0.00053440907,2.89711559 C0.00053440907,1.67400015 1.37429568,0.68294664 3.06753632,0.68294664 C4.76077697,0.68294664 6.13453824,1.67400015 6.13453824,2.89711559 Z M1.70442436,2.38615353 C1.42221759,2.38615353 1.19325738,2.61502195 1.19325738,2.89711559 C1.19325738,3.17920923 1.42221759,3.40807766 1.70442436,3.40807766 C1.98663114,3.40807766 2.21559135,3.17920923 2.21559135,2.89711559 C2.21559135,2.61502195 1.98663114,2.38615353 1.70442436,2.38615353 Z M3.06753632,2.38615353 C2.78532955,2.38615353 2.55636934,2.61502195 2.55636934,2.89711559 C2.55636934,3.17920923 2.78532955,3.40807766 3.06753632,3.40807766 C3.3497431,3.40807766 3.57870331,3.17920923 3.57870331,2.89711559 C3.57870331,2.61502195 3.3497431,2.38615353 3.06753632,2.38615353 Z M4.43064829,2.38615353 C4.14844151,2.38615353 3.9194813,2.61502195 3.9194813,2.89711559 C3.9194813,3.17920923 4.14844151,3.40807766 4.43064829,3.40807766 C4.71285506,3.40807766 4.94181527,3.17920923 4.94181527,2.89711559 C4.94181527,2.61502195 4.71285506,2.38615353 4.43064829,2.38615353 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solid",
    transform: "translate(-176.000000, -1339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "comment-alt",
    transform: "translate(176.000000, 1339.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-2)",
    fill: "#A6A6A6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Purple",
    x: 0,
    y: 0,
    width: 6.13453824,
    height: 6.13453824
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAlt);
export default __webpack_public_path__ + "static/media/comment-alt.7ed6182bc6aa86067879ed85a4838786.svg";
export { ForwardRef as ReactComponent };